import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import Fullcalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import { Spanish } from "flatpickr/dist/l10n/es.js"; // Importa la localización en español
import "flatpickr/dist/themes/material_blue.css"; // O el tema que prefieras
import React, { useEffect, useRef, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Flatpickr from "react-flatpickr";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import medicGeekApi from "../../config/axiosConfig";
import {
  showConfirmationAlert,
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "./../../components/alerts";
import ConsultaForm from "./../Consulta/ConsultaForm";
import "./../../styles/calendar.css";

const MyCalendar = ({ setSelectedPaciente, setCurrentForm, currentForm }) => {
  const [events, setEvents] = useState([]);
  const [selectedPacienteLocal, setSelectedPacienteLocal] = useState(null);
  const [selectedFormulario, setSelectedFormulario] = useState("");

  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCalendarLocal, setselectedCalendarLocal] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pacientes, setPacientes] = useState([]);
  const [paciente, setPaciente] = useState([]);
  const [infEvento, setInfEvento] = useState([]);
  const [formulario, setFormulario] = useState({
    categoriaNm: "",
    horaFormateada: "",
    fechaCita: new Date().toISOString().slice(0, 10),
    nombrePaciente: "",
    nombreDelPaciente: "",
    direccionPaciente: "",
    contactoPaciente: "",
    emailPaciente: "",
    notaCita: "",
    estatusCalendar: "Activo",
    pacienteId: "",
  });
  const [formularioInicial, setFormularioInicial] = useState({});
  const [categorias, setCategorias] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [isPacienteModalOpen, setIsPacienteModalOpen] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isButtonDeleteDisabled, setIsButtonDeleteDisabled] = useState(false);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState(null);
  const [pacienteConsulta, setPacienteConsulta] = useState(null);
  const [categoriasMap, setCategoriasMap] = useState({});
  const [paletaColorData, setPaletaColorData] = useState([]); // Define e inicializa paletaColorData
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selected, setSelected] = useState(false);
  const [pendingAppointments, setPendingAppointments] = useState(null);
  
  const datePickerRef = useRef(null); // Define the datePickerRef properly

  //  Enviar Paciente a Consulta

  const [showForm, setShowForm] = useState(false);

  // Pantalla de Carga
  const [isLoading, setIsLoading] = useState(false); // Estado de carga

  const openModal = (calendar, customPageSize = 10) => {
    setselectedCalendarLocal(calendar);
    setPageSize(customPageSize);

    if (calendar) {
      setIsEditing(true);
      setFormulario({
        categoryId: calendar.categoryId,
        categoriaNm: calendar.categoryNm,
        nombrePaciente: calendar.nombrePaciente || "",
        direccionPaciente: calendar.direccionPaciente,
        contactoPaciente: calendar.contactoPaciente,
        emailPaciente: calendar.emailPaciente,
        categoria: calendar.categoryId,
        fechaCita: calendar.fechaCita,
        horaFormateada: calendar.horaFormateada,
        notaCita: calendar.notaCita,
        estatusCalendar: calendar.estatusCalendar,

        nombreDelPaciente: calendar.nombreDelPaciente || "",
      });
      setSelectedPaciente(calendar.paciente);
      setFormularioInicial({ ...formulario });
    } else {
      setIsEditing(false);
      setFormulario({
        categoriaNm: "",
        nombrePaciente: "",
        direccionPaciente: "",
        contactoPaciente: "",
        emailPaciente: "",
        categoria: "",
        fechaCita: "",
        horaFormateada: "",
        notaCita: "",
        estatusCalendar: "Nuevo",
      });
      setSelectedPaciente(null);
      setFormularioInicial({});
    }
    setModalOpen(true);
    setIsButtonDisabled(false);
    setIsButtonDeleteDisabled(true);
  };

  const closeModal = () => {
    setselectedCalendarLocal(null);
    setIsEditing(false);
    setModalOpen(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (datePickerRef.current) {
      Flatpickr(datePickerRef.current, {
        defaultDate: formulario.fechaCita || new Date(), // Usar formulario.fechaCita o fecha actual
        onChange: (selectedDate) => {
          if (selectedDate.length > 0) {
            // Formato de fecha a DD/MM/YYYY
            const fechaFormateada = `${String(
              selectedDate[0].getDate()
            ).padStart(2, "0")}/${String(
              selectedDate[0].getMonth() + 1
            ).padStart(2, "0")}/${selectedDate[0].getFullYear()}`;
            setFormulario((prevFormulario) => ({
              ...prevFormulario,
              fechaCita: fechaFormateada, // Actualizar con la fecha formateada
            }));
          }
        },
        locale: {
          ...Spanish, // Usar la localización en español
          firstDayOfWeek: 0, // Iniciar la semana en domingo
        },
        dateFormat: "d/m/Y", // Mostrar en formato día/mes/año
      });
    }
  }, [formulario.fechaCita]); // Re-ejecutar este efecto cuando fechaCita cambia

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const patientsResponse = await medicGeekApi.get(
        `/patients?search=${searchTerm}`,
        {
          params: {
            $or: [
              { pcteNom: { $regex: searchTerm, $options: "i" } },
              { pcteNom2: { $regex: searchTerm, $options: "i" } },
              { pcteApe1: { $regex: searchTerm, $options: "i" } },
            ],
          },
        }
      );

      const sortedPacientes = patientsResponse.data.sort(
        (a, b) => a.pcteId - b.pcteId
      );
      setPacientes(sortedPacientes);

      const [calendarResponse, categoriasResponse, paletaColorResponse] =
        await Promise.all([
          medicGeekApi.get(`/calendars/detail`),
          medicGeekApi.get(`/categorys/detail`),
          medicGeekApi.get(`/paletaColors`),
        ]);

      // Cargar los datos de los eventos del calendario desde el backend
      const calendarData = calendarResponse.data;
      const categoriasData = categoriasResponse.data;
      const paletaColorData = paletaColorResponse.data;

      setPaletaColorData(paletaColorData); // Actualiza el estado con los datos

      // Mapea las categorías a un mapa para futuras referencias
      const categoriasMap = {};
      categoriasData.forEach((categoria) => {
        categoriasMap[categoria.categoryNm] = categoria.categoryId;
      });
      // Crear un mapa para buscar colores por colorId
      const paletaColorMap = {};
      paletaColorData.forEach((paletaColor) => {
        paletaColorMap[paletaColor.colorId] = paletaColor.colorRgb;
      });

      // Obtener el colorRgb correspondiente para cada categoría
      const categoryDataWithColor = paletaColorData.map((category) => ({
        ...category,
        colorRgb: paletaColorMap[category.colorId] || "rgb(255, 0, 0)", // Proporciona un color por defecto en caso de que no haya una correspondencia
      }));

      // Ordena los eventos por hora
      const eventosOrdenados = calendarData.sort((a, b) => {
        const horaEventoA = a.horaCita;
        const horaEventoB = b.horaCita;
        return horaEventoA.localeCompare(horaEventoB);
      });

      // Mapea los datos del calendario al formato esperado por FullCalendar
      const formattedEvents = eventosOrdenados
        .filter(
          (event) =>
            event.fechaCita && event.horaCita
        ) // Filtra eventos válidos
        .map((event) => {
          const categoryId = categoriasMap[event.category.categoryNm] || null;
          const paletaColorId = categoryId
            ? categoriasData.find(
                (categoria) => categoria.categoryId === categoryId
              ).colorId
            : null;
          const colorRgb = paletaColorMap[paletaColorId] || "rgb(255, 0, 0)"; // Proporciona un color por defecto en caso de que no haya una correspondencia
          const paginate = (pageNumber) => {
            setCurrentPage(pageNumber);
          };

          const pageSize = 5; // Número de pacientes por página

          const totalPacientes = pacientes.length;
          const indexOfLastPaciente = currentPage * pageSize;
          const indexOfFirstPaciente = indexOfLastPaciente - pageSize;
          const currentPacientes = pacientes.slice(
            indexOfFirstPaciente,
            indexOfLastPaciente
          );

          return {
  calendarId: event.calendarId,
  title: `${event.patient.pcteNom} ${event.patient.pcteApe1}`,
  nombreDelPaciente: `${event.patient.pcteNom} ${event.patient.pcteNom2} ${event.patient.pcteApe1} ${event.patient.pcteApe2}`,
  pacienteId: event.patient.pcteId,

  estatusCalendar: event.estatus,
  estatus: event.estatus,

  fechaCita: event.fechaCita,
  horaCita: event.horaCita,

  direccionPaciente: event.patient.pcteDir,
  contactoPaciente: event.patient.pcteTel || event.patient.pcteCel,
  emailPaciente: event.patient.pcteEmail,

  start: convertirFechaHora(
    event.fechaCita,
    event.horaCita
  ),

  end: convertirFechaHora(
    event.fechaCita,
    event.horaCita
  ),

  notaCita: event.notaCita,

  categoryNm: event.category.categoryNm,
  categoryId: event.category.categoryId,

  colorId: paletaColorId,
  colorRgb,
};
        });
      setEvents(formattedEvents);
      setCategorias(categoriasData);
      setCategoriasMap(categoriasMap);
    } catch (error) {
      console.error("Error al cargar datos:", error);
    } finally {
      setIsLoading(false); // Ocultar pantalla de carga cuando termine
    }
  };

  function obtenerHoraAMPM(fechaCita) {
    if (fechaCita) {
      const partes = fechaCita.split(" ");
      if (partes.length === 2) {
        return partes[1];
      } else {
        return "Formato de hora inválido";
      }
    } else {
      return "Formato de hora inválido";
    }
  }

  function convertirFechaHora(fechaCita) {
    if (fechaCita) {
      // Divide la fecha en partes: día, mes, año, hora y ampm
      const [fechaPartes, horaPartes] = fechaCita.split(" ");
      const [dia, mes, año] = fechaPartes.split("/");
      const [hora12, minutos] = horaPartes.split(":");
      const ampm = horaPartes.trim(); // Elimina espacios en blanco innecesarios

      let hora24 = hora12;

      if (ampm === "PM" && hora12 !== "12") {
        hora24 = String(Number(hora12) + 12);
      } else if (ampm === "AM" && hora12 === "12") {
        hora24 = "00";
      }

      // Formatea la fecha y hora en formato ISO8601
      const fechaISO8601 = `${año}-${mes}-${dia}T${hora24}:${minutos}:00`;

      return fechaISO8601;
    } else {
      return ""; // Devuelve una cadena vacía si no se proporciona fechaCita
    }
  }

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  const openPacienteModal = () => {
    setIsPacienteModalOpen(true);

    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
        // console.log('Forzado el enfoque en el input', searchInputRef.current);
      }
    }, 100); // Un retraso corto
  };

  const closePacienteModal = () => {
    setIsPacienteModalOpen(false);
  };
  // Función para formatear la hora con AM/PM
  function formatearHora(fecha) {
    const ampm = fecha.getHours() >= 12 ? "PM" : "AM";
    let horas = fecha.getHours() % 12;
    horas = horas === 0 ? 12 : horas;
    const minutos = fecha.getMinutes();
    const horaFormateada = `${horas.toString().padStart(2, "0")}:${minutos
      .toString()
      .padStart(2, "0")} ${ampm}`;
    return horaFormateada;
  }
  // Función para formatear la fecha y hora en el formato deseado
  function formatearFechaHora(fecha) {
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();

    // Formatea la hora con AM/PM
    const horaFormateada = formatearHora(fecha);

    return `${dia}/${mes}/${año} ${horaFormateada}`;
  }
  // Función para formatear la fecha de la cita en el formato deseado (sin hora)
  function formatearFechaCita(fecha) {
    const dia = (fecha.getDate() + 1).toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0"); // Ajusta el mes sumando 1
    const año = fecha.getFullYear();
    return `${dia}/${mes}/${año}`;
  }

  function formatearHora12Horas(horaFormateada) {
    const [hora, minutos] = horaFormateada.split(":");
    const horaNumero = parseInt(hora);

    // Función auxiliar para agregar un cero delante de números menores que 10
    const agregarCero = (numero) => (numero < 10 ? `0${numero}` : `${numero}`);

    if (horaNumero === 0) {
      return `12:${minutos} AM`;
    } else if (horaNumero < 12) {
      return `${agregarCero(horaNumero)}:${minutos} AM`;
    } else if (horaNumero === 12) {
      return `12:${minutos} PM`;
    } else {
      return `${agregarCero(horaNumero - 12)}:${minutos} PM`;
    }
  }
  // Filtro para los pacientes en funcion de termino de busqueda
  const filteredPacientes = pacientes.filter((paciente) => {
    const fullName =
      `${paciente.pcteNom} ${paciente.pcteNom2} ${paciente.pcteApe1} ${paciente.pcteApe2}`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  const totalPages = Math.ceil(filteredPacientes.length / itemsPerPage);

  const handlePacienteSelection = (paciente) => {
    if (paciente) {
      setFormulario((prevFormulario) => ({
        ...prevFormulario,
        nombreDelPaciente: `${paciente.pcteNom} ${paciente.pcteNom2} ${paciente.pcteApe1} ${paciente.pcteApe2}`,
        direccionPaciente: paciente.pcteDir,
        contactoPaciente: paciente.pcteTel || paciente.pcteCel,
        emailPaciente: paciente.pcteEmail,
      }));

      setModalOpen(true);
      setIsButtonDisabled(true);
      closePacienteModal();
      setPacienteSeleccionado(paciente); // Establece pacienteSeleccionado aquí
    } else {
      console.error("El paciente seleccionado es nulo.");
    }
  };

  const handleEventClick = async (eventClickInfo) => {
    const event = eventClickInfo.event;
    const calendarId = event.extendedProps.calendarId;
    const categoryId = event.extendedProps.categoryId;
    const categoria = event.extendedProps.categoryNm;
    const horaCita = event.extendedProps.horaCita;
    const horaCitaDate = new Date(`1/1/2000 ${horaCita}`);
    const horaFormateada = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(horaCitaDate);
    const estatusCalendar = event.extendedProps.estatusCalendar;
    const notaCita = event.extendedProps.notaCita;
    const nombreDelPaciente = event.extendedProps.nombreDelPaciente;
    const pacienteId = event.extendedProps.pacienteId;
    const contactoPaciente = event.extendedProps.contactoPaciente;
    const direccionPaciente = event.extendedProps.direccionPaciente;
    const emailPaciente = event.extendedProps.emailPaciente;
    const fechaCita = event.extendedProps.fechaCita;
    const [fecha, hora] = fechaCita?.split(" ");
    const fechaFormateada = formatearFecha(fecha);

    function formatearFecha(fecha) {
      const [dia, mes, año] = fecha.split("/");
      return `${año}-${mes}-${dia}`;
    }

    try {
      // Realizar una solicitud adicional para obtener información de pacientes
      medicGeekApi.get("/patients").then((responsePatients) => {
        const patientsData = responsePatients.data;
        const paciente = patientsData.find(
          (paciente) => paciente.pcteId === pacienteId
        );

        setFormulario((prevFormulario) => ({
          ...prevFormulario,
          calendarId: calendarId,
          estatusCalendar: estatusCalendar,
          nombrePaciente: event.title,
          nombreDelPaciente: nombreDelPaciente,
          direccionPaciente: direccionPaciente,
          contactoPaciente: contactoPaciente,
          emailPaciente: emailPaciente,
          categoriaNm: categoria,
          categoryId: categoryId,
          horaFormateada: hora,
          fechaCita: fechaCita,
          notaCita: notaCita,
        }));

        setIsEditing(true);
        setModalOpen(true);
        setIsButtonDisabled(true);
        setIsButtonDeleteDisabled(false);

        setPacienteConsulta(paciente);
        setPacienteSeleccionado(paciente);
        setInfEvento(event.extendedProps);

        // console.log(`El paciente que seleccionó es ${nombreDelPaciente} (ID: ${pacienteId})`);

        // console.log('Información de la Cita', infEvento);
      });
    } catch (error) {
      console.error("Error al obtener la información del paciente:", error);
    }
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const saveAppointment = () => {
    if (!pacienteSeleccionado || !formulario.categoriaNm) {
      showErrorAlert(
        "Debes seleccionar un paciente y/o un motivo de consulta antes de guardar la cita."
      );
      return;
    }

    try {
      // Obtener la fecha actual y formatearla
      const fechaActual = new Date();
      const fechaCitaReg = formatearFechaHora(fechaActual);
      const cita = formulario.fechaCita;
      // if (isNaN(cita.getTime())) {
      //   showErrorAlert(
      //     "La fecha de cita es inválida. Por favor, verifique el formato."
      //   );
      //   return;
      // }
      const horaFormateada = formulario.horaFormateada.trim();
      const horaFormateada12Horas = formatearHora12Horas(horaFormateada);
      const categoryId = categoriasMap[formulario.categoriaNm];
      if (!categoryId) {
        showErrorAlert("La categoría seleccionada no es válida.");
        return;
      }
      const nuevaCita = {
        pcteId: pacienteSeleccionado.pcteId,
        categoryId: categoryId,
        fechaCitaReg: fechaCitaReg,
        fechaCita: `${cita} ${horaFormateada12Horas}`,
        horaCita: horaFormateada12Horas,
        notaCita: formulario.notaCita,
        estatus: "Activo",
      };

      medicGeekApi
        .post("/calendars", nuevaCita)
        .then((response) => {
          closeModal();
          showSuccessAlert("Cita creada con éxito.", 3000);
          fetchData();
        })
        .then((response) => {
          closeModal();
        })
        .catch((error) => {
          console.error("Error al crear la cita", error);
        });
    } catch (error) {
      console.error("Error al crear la Cita:", error);
      showErrorAlert("Hubo un error al crear la Cita");
    }
  };

  const editAppointment = async () => {
    const horaFormateada = formulario.horaFormateada.trim();
    const horaFormateada12Horas = formatearHora12Horas(horaFormateada);
    const cita = formulario.fechaCita;

    // Verificar que la cita y la hora estén correctamente formateadas

    if (formulario && formulario.calendarId) {
      const { calendarId } = formulario;
      const categoryId = categoriasMap[formulario.categoriaNm];

      // Separar la fecha de la hora original para evitar duplicaciones
      const [fechaOriginal, horaOriginal] = cita.split(" "); // Separa la fecha y la hora

      // Verificar si la hora ya está incluida en la fechaCita
      let fechaCita = cita;

      // Solo agregar la hora si no está incluida ya en la cita
      if (horaOriginal !== horaFormateada12Horas) {
        fechaCita = `${fechaOriginal} ${horaFormateada12Horas}`.trim();
      }

      const notaCita = formulario.notaCita;

      // Verificar si hubo cambios en la cita
      const cambiosEnCita =
        categoryId !== formulario.categoryId ||
        fechaCita !== cita || // Comparar fechaCita con la original (sin la hora duplicada)
        notaCita !== formulario.notaCita ||
        horaFormateada12Horas !== formulario.horaCita;

      if (cambiosEnCita) {
        const confirmResult = await showConfirmationAlert(
          "Confirmación",
          "¿Estás seguro de que deseas actualizar esta cita?"
        );

        if (confirmResult.isConfirmed) {
          const updatedCalendar = {
            calendarId,
            categoryId,
            fechaCita, // Solo se actualiza la fechaCita con la hora si es necesario
            horaCita: horaFormateada12Horas, // Actualizar solo la hora, no duplicarla
            notaCita,
            estatus: "Activo",
          };

          try {
            // Aquí podrías realizar la actualización con la API
            await medicGeekApi.patch(
              `/calendars/${calendarId}`,
              updatedCalendar
            );
            closeModal();
            showSuccessEditAlert("Cita Actualizada con éxito.");
            fetchData();
          } catch (error) {
            console.error("Error al actualizar la cita", error);
          }
        }
      } else {
        if (
          window.confirm(
            "No se realizaron cambios en la cita. ¿Desea cerrar el modal?"
          )
        ) {
          closeModal();
        }
      }
    }
  };

  const deleteAppointment = async () => {
    if (formulario && formulario.calendarId) {
      const { calendarId, estatus } = formulario;

      // Verifica que el estatus actual sea diferente de 'Cancelada' antes de continuar
      if (estatus !== "Cancelada") {
        const confirmResult = await showConfirmationAlert(
          "Confirmación",
          "¿Estás seguro de que deseas cancelar esta cita?"
        );

        if (confirmResult.isConfirmed) {
          const updatedCalendar = {
            calendarId,
            estatus: "Cancelada",
          };

          try {
            await medicGeekApi.patch(
              `/calendars/${calendarId}`,
              updatedCalendar
            );
            closeModal();
            showSuccessAlert("Cita Cancelada con éxito.");
            fetchData();
          } catch (error) {
            console.error("Error al Cancelar la cita", error);
          }
        }
      } else {
        console.error('La cita ya está marcada como "Cancelada".');
      }
    } else {
      if (
        window.confirm(
          "No se realizaron cambios en la cita. ¿Desea cerrar el modal?"
        )
      ) {
        closeModal();
      }
    }
  };

  const handleEnviarConsultaClick = async (paciente, infEvento) => {
    try {
      const pacienteId = paciente?.pcteId;
      const { categoryId, estatusCalendar, calendarId, notaCita } = formulario;
      const consultaCita = {
        ...paciente,
        categoryId,
        estatusCalendar,
        calendarId,
        notaCita,
      };

      setSelectedPaciente(consultaCita);
      setCurrentForm("consultaForm");
      setSelected(true);

      navigate(`/patients/${pacienteId}/encounters/0`);
    } catch (error) {
      console.error("Error al cargar la última consulta:", error);
    }
  };

  const handleNoAsistio = async (paciente) => {

  if (!paciente) return;

  const confirmacion = window.confirm(
    `¿Confirma que el paciente no asistió a la cita?`
  );

  if (!confirmacion) return;

  try {

    // =====================================================
    // ACTUALIZAR API
    // =====================================================

    await medicGeekApi.patch(
      `/calendars/${paciente.calendarId}`,
      {
        estatus: "No Asistio",
      }
    );

    // =====================================================
    // ACTUALIZAR FORMULARIO MODAL
    // =====================================================

    setFormulario((prev) => ({
      ...prev,
      estatusCalendar: "No Asistio",
    }));

    // =====================================================
    // ACTUALIZAR FULLCALENDAR
    // =====================================================

    setEvents((prevEvents) =>
  prevEvents.map((event) =>
    event.calendarId === paciente.calendarId
      ? {
          ...event,
          estatus: "No Asistio",
          estatusCalendar: "No Asistio",
        }
      : event
  )
);

    // =====================================================
    // ACTUALIZAR DASHBOARD
    // =====================================================

    setPendingAppointments((prev) =>
      prev.map((item) =>
        item.calendarId === paciente.calendarId
          ? {
              ...item,
              estatus: "No Asistio",
            }
          : item
      )
    );

    // =====================================================
    // ALERTA
    // =====================================================

    alert("La cita fue marcada como No Asistió.");

  } catch (error) {

    console.error(
      "Error actualizando estatus:",
      error
    );

    alert(
      "Ocurrió un error actualizando el estatus."
    );
  }
};

  return (
    <div>
      {isLoading && (
        <div className="pro-loading-overlay">
          <div className="pro-loading-card">
            {/* LOGO / ICON */}
            <div className="pro-loading-icon">
              <i className="bi bi-heart-pulse-fill"></i>
            </div>
            {/* SPINNER */}
            <div className="pro-loading-spinner"></div>
            {/* TEXT */}
            <h5 className="pro-loading-title">
              Cargando Información
            </h5>
            <p className="pro-loading-subtitle">
              Espere un momento mientras procesamos los datos...
            </p>
          </div>
        </div>
      )}
      {/* El contenido principal de la página */}
      {!isLoading && (
        <div>
          <div className="agenda-banner">
            <div className="agenda-banner__content">     
              <div className="agenda-banner__title-wrapper">
                <div className="agenda-banner__icon">
                  <i className="bi bi-calendar2-week-fill"></i>
                </div>
                <div>
                  <h2 className="agenda-banner__title">
                    Agenda
                  </h2>
                  <span className="agenda-banner__subtitle">
                    Gestión y control de citas médicas
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="agenda-banner__button"
                title="Crear Nueva Cita"
                onClick={() => openModal(null)}
              >
                <i className="bi bi-file-earmark-plus-fill"></i>
                Nueva Cita
              </button>
            </div>
          </div>
          
          <div
            className="mt-4"
          >
            <div>

            <Fullcalendar
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin
              ]}

              initialView={"dayGridMonth"}

              headerToolbar={{
                start: "today prev,next",
                center: "title",
                end: "dayGridMonth,timeGridWeek,timeGridDay",
              }}

              buttonText={{
                today: "Hoy",
                month: "Mes",
                week: "Semana",
                day: "Día",
              }}

              /* ===================================================== */
              /* CONFIGURACION GENERAL */
              /* ===================================================== */

              height={"auto"}
              contentHeight={"auto"}
              events={events}
              themeSystem="bootstrap5"
              eventDisplay="block"
              dayMaxEventRows={2}
              dayMaxEvents={2}
              eventMaxStack={2}
              moreLinkClick={(info) => {
                return "popover";
              }}
              fixedWeekCount={false}

              expandRows={true}

              /* ===================================================== */
              /* DISEÑO EVENTOS */
              /* ===================================================== */

              eventContent={(eventInfo) => {

                const hora =
                  eventInfo.event.extendedProps.horaCita || "";

                const categoria =
                  eventInfo.event.extendedProps.categoryNm || "";

                const estatus =
                  eventInfo.event.extendedProps.estatus ||
                  eventInfo.event.extendedProps.estatusCalendar ||
                  "Activo";

                const paciente =
                  eventInfo.event.title || "";

                /* ===================================================== */
                /* ESTATUS */
                /* ===================================================== */

                let statusClass = "activa";
                let statusLabel = "";

                if (estatus === "Completada") {
                  statusClass = "completada";
                  statusLabel = "✓ COMPLETADA";
                }

                if (estatus === "Cancelada") {
                  statusClass = "cancelada";
                  statusLabel = "✕ CANCELADA";
                }

                if (estatus === "No Asistio") {
                  statusClass = "no-asistio";
                  statusLabel = "⚠ NO ASISTIÓ";
                }

                /* ===================================================== */
                /* CONTENEDOR */
                /* ===================================================== */

                const container = document.createElement("div");

                container.className =
                  `calendar-event-card ${statusClass}`;

                container.innerHTML = `

                  ${
                    statusLabel
                      ? `
                        <div class="calendar-event-badge">
                          ${statusLabel}
                        </div>
                      `
                      : ""
                  }

                  <div class="calendar-event-hour">
                    ${hora}
                  </div>

                  <div class="calendar-event-category">
                    ${categoria}
                  </div>

                  <div class="calendar-event-patient">
                    ${paciente}
                  </div>

                `;

                return {
                  domNodes: [container]
                };
              }}

              /* ===================================================== */
              /* EVENT CLICK */
              /* ===================================================== */

              eventClick={handleEventClick}

              /* ===================================================== */
              /* HORARIO LABORAL */
              /* ===================================================== */

              businessHours={{
                daysOfWeek: [1, 2, 3, 4, 5, 6],
                startTime: "06:00",
                endTime: "19:00",
              }}
              allDaySlot={true}
            />

            {/* ===================================================== */}
            {/* MODAL */}
            {/* ===================================================== */}

            <Modal
              isOpen={modalOpen}
              toggle={closeModal}
              centered
              scrollable
              backdrop="static"
              fade={true}
              keyboard={false}
              className="pro-modal"
              style={{
                maxWidth: "78rem",
                zIndex: 99999,
              }}
            >

              {/* ===================================================== */}
              {/* HEADER */}
              {/* ===================================================== */}

              <ModalHeader
                toggle={closeModal}
                className="pro-modal-header"
              >

                <div className="pro-modal-header-content">

                  <div className="pro-modal-icon">
                    <i className="bi bi-calendar2-check"></i>
                  </div>

                  <div>

                    <h4 className="mb-0">
                      {
                        isEditing
                          ? "Editar Cita"
                          : "Crear Nueva Cita"
                      }
                    </h4>

                    <span>
                      Gestión y programación de citas médicas
                    </span>

                  </div>

                </div>

              </ModalHeader>

              {/* ===================================================== */}
              {/* BODY */}
              {/* ===================================================== */}

              <ModalBody className="pro-modal-body">

                <div className="row g-4">

                  {/* ===================================================== */}
                  {/* LEFT SIDE */}
                  {/* ===================================================== */}

                  <div className="col-12 col-xl-6">

                    <div className="pro-section-card h-100">

                      <div className="pro-section-title mb-4">

                        <div className="pro-section-icon">
                          <i className="bi bi-journal-medical"></i>
                        </div>

                        <div>

                          <h4>Datos de la Cita</h4>

                          <span>
                            Información general y programación
                          </span>

                        </div>

                      </div>

                      <Form>

                        <div className="row g-4">

                          {/* CATEGORIA */}

                          <div className="col-md-7">

                            <label className="pro-label">
                              Motivo de Consulta
                            </label>

                            <select
                              className="pro-input"
                              value={formulario.categoriaNm}
                              onChange={(e) => {

                                const categoriaSeleccionada =
                                  e.target.value;

                                setFormulario({
                                  ...formulario,
                                  categoriaNm:
                                    categoriaSeleccionada,
                                });
                              }}
                            >

                              <option value="">
                                Seleccione una categoría
                              </option>

                              {
                                categorias.map((categoria) => (
                                  <option
                                    key={categoria.id}
                                    value={categoria.categoryNm}
                                  >
                                    {categoria.categoryNm}
                                  </option>
                                ))
                              }

                            </select>

                          </div>

                          {/* ESTATUS */}

                          <div className="col-md-5">

                            <label className="pro-label">
                              Estatus
                            </label>

                            <input
                              type="text"
                              className={`pro-input status-input ${
                                formulario.estatusCalendar === "Completada"
                                  ? "status-completada"
                                  : formulario.estatusCalendar === "Cancelada"
                                  ? "status-cancelada"
                                  : formulario.estatusCalendar === "No Asistio"
                                  ? "status-no-asistio"
                                  : "status-activa"
                              }`}
                              value={formulario.estatusCalendar}
                              disabled
                            />

                          </div>

                          {/* NOTA */}

                          <div className="col-12">

                            <label className="pro-label">
                              Nota
                            </label>

                            <textarea
                              className="pro-input pro-textarea"
                              value={formulario.notaCita}
                              onChange={(e) =>
                                setFormulario({
                                  ...formulario,
                                  notaCita: e.target.value,
                                })
                              }
                              placeholder="Agregar observaciones de la cita..."
                            />

                          </div>

                          {/* FECHA */}

                          <div className="col-md-6">

                            <label className="pro-label">
                              Fecha
                            </label>

                            <Flatpickr
                              value={formulario.fechaCita}
                              onChange={(selectedDate) => {

                                if (selectedDate.length > 0) {

                                  const fechaFormateada =
                                    `${String(
                                      selectedDate[0].getDate()
                                    ).padStart(2, "0")}/${String(
                                      selectedDate[0].getMonth() + 1
                                    ).padStart(
                                      2,
                                      "0"
                                    )}/${selectedDate[0].getFullYear()}`;

                                  setFormulario(
                                    (prevFormulario) => ({
                                      ...prevFormulario,
                                      fechaCita:
                                        fechaFormateada,
                                    })
                                  );
                                }
                              }}
                              options={{
                                dateFormat: "d/m/Y",
                                locale: {
                                  ...Spanish,
                                  firstDayOfWeek: 0,
                                  minDate: "today",
                                },
                              }}
                              className="pro-input"
                            />

                          </div>

                          {/* HORA */}

                          <div className="col-md-6">

                            <label className="pro-label">
                              Hora
                            </label>

                            <input
                              type="time"
                              className="pro-input"
                              value={formulario.horaFormateada}
                              onChange={(e) =>
                                setFormulario({
                                  ...formulario,
                                  horaFormateada:
                                    e.target.value,
                                })
                              }
                            />

                          </div>

                        </div>

                      </Form>

                    </div>

                  </div>

                  {/* ===================================================== */}
                  {/* RIGHT SIDE */}
                  {/* ===================================================== */}

                  <div className="col-12 col-xl-6">

                    <div className="pro-section-card h-100">

                      <div className="pro-section-title mb-4">

                        <div className="pro-section-icon green">
                          <i className="bi bi-person-vcard"></i>
                        </div>

                        <div>

                          <h4>Datos del Paciente</h4>

                          <span>
                            Información vinculada a la cita
                          </span>

                        </div>

                      </div>

                      <Form>

                        <div className="row g-4">

                          {/* PACIENTE */}

                          <div className="col-12">

                            <label className="pro-label">
                              Paciente
                            </label>

                            <div className="d-flex gap-2">

                              <input
                                type="text"
                                className="pro-input"
                                value={
                                  formulario.nombreDelPaciente || ""
                                }
                                disabled
                              />

                              <button
                                type="button"
                                onClick={openPacienteModal}
                                className="pro-btn-icon"
                                disabled={isButtonDisabled}
                              >

                                <i className="bi bi-search"></i>

                              </button>

                            </div>

                          </div>

                          {/* DIRECCION */}

                          <div className="col-12">

                            <label className="pro-label">
                              Dirección
                            </label>

                            <input
                              type="text"
                              className="pro-input"
                              value={
                                formulario.direccionPaciente
                              }
                              disabled
                            />

                          </div>

                          {/* CONTACTO */}

                          <div className="col-md-6">

                            <label className="pro-label">
                              Contacto
                            </label>

                            <input
                              type="text"
                              className="pro-input"
                              value={
                                formulario.contactoPaciente
                              }
                              disabled
                            />

                          </div>

                          {/* EMAIL */}

                          <div className="col-md-6">

                            <label className="pro-label">
                              Email
                            </label>

                            <input
                              type="text"
                              className="pro-input"
                              value={formulario.emailPaciente}
                              disabled
                            />

                          </div>

                        </div>

                      </Form>

                    </div>

                  </div>

                </div>

              </ModalBody>

              {/* ===================================================== */}
              {/* FOOTER */}
              {/* ===================================================== */}

              <div className="pro-modal-footer">

                <div className="pro-footer-left">

                  <button
                    className="pro-btn-success"
                    onClick={() =>
                      handleEnviarConsultaClick(
                        pacienteConsulta
                      )
                    }
                    disabled={
                      isButtonDeleteDisabled ||
                      formulario.estatusCalendar === "Cancelada" ||
                      formulario.estatusCalendar === "Completada" ||
                      formulario.estatusCalendar === "No Asistio"
                    }
                  >

                    <i className="bi bi-file-earmark-medical"></i>

                    <span>
                      Enviar a Consulta
                    </span>

                  </button>
                </div>

                <div className="pro-footer-right">
                  <button
                    className="pro-btn-delete"
                    onClick={deleteAppointment}
                    disabled={isButtonDeleteDisabled}
                  >

                    <i className="bi bi-trash3-fill"></i>

                    <span>
                      Eliminar
                    </span>

                  </button>

                  <button
                    className="pro-btn-save"
                    onClick={
                      isEditing
                        ? editAppointment
                        : saveAppointment
                    }
                  >

                    <i className="bi bi-floppy-fill"></i>

                    <span>
                      {
                        isEditing
                          ? "Actualizar Cita"
                          : "Guardar"
                      }
                    </span>

                  </button>

                  <button
                    className="pro-btn-cancel"
                    onClick={closeModal}
                  >

                    <i className="bi bi-x-circle"></i>

                    <span>
                      Cancelar
                    </span>

                  </button>

                </div>

              </div>

            </Modal>

            <Modal
              isOpen={isPacienteModalOpen}
              toggle={closePacienteModal}
              centered
              scrollable
              className="pro-modal"
              style={{
                maxWidth: "55rem",
                zIndex: 99999,
              }}
            >

              {/* ===================================================== */}
              {/* HEADER */}
              {/* ===================================================== */}

              <ModalHeader
                toggle={closePacienteModal}
                className="pro-modal-header"
              >

                <div className="pro-modal-header-content">

                  <div className="pro-modal-icon green">
                    <i className="bi bi-people-fill"></i>
                  </div>

                  <div>

                    <h4 className="mb-0">
                      Seleccionar Paciente
                    </h4>

                    <span>
                      Buscar y seleccionar paciente
                    </span>

                  </div>

                </div>

              </ModalHeader>

              {/* ===================================================== */}
              {/* BODY */}
              {/* ===================================================== */}

              <ModalBody className="pro-modal-body">

                {/* BUSCADOR */}

                <div className="mb-4">

                  <label className="pro-label">
                    Buscar Paciente
                  </label>

                  <div className="position-relative">

                    <i
                      className="bi bi-search"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "14px",
                        transform: "translateY(-50%)",
                        color: "#94a3b8",
                        fontSize: "14px",
                        zIndex: 2,
                      }}
                    />

                    <input
                      type="text"
                      className="pro-input"
                      placeholder="Buscar por nombre..."
                      value={searchTerm}
                      onChange={(e) =>
                        setSearchTerm(e.target.value)
                      }
                      ref={searchInputRef}
                      style={{
                        paddingLeft: "40px",
                      }}
                    />

                  </div>

                </div>

                {/* LISTADO */}

                <div className="patient-list-container">

                  {filteredPacientes
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((paciente) => {

                      const fullName = [
                        paciente.pcteNom,
                        paciente.pcteNom2,
                        paciente.pcteApe1,
                        paciente.pcteApe2,
                      ]
                        .filter(Boolean)
                        .join(" ");

                      return (

                        <div
                          key={paciente.pcteId}
                          className="patient-item"
                        >

                          <div className="patient-info">

                            <div className="patient-avatar">
                              {paciente.pcteNom?.charAt(0)}
                            </div>

                            <div>

                              <div className="patient-name">
                                {fullName}
                              </div>

                              <div className="patient-id">
                                Expediente #
                                {paciente.pcteId
                                  .toString()
                                  .padStart(6, "0")}
                              </div>

                            </div>

                          </div>

                          <button
                            className="pro-btn-save"
                            onClick={() =>
                              handlePacienteSelection(paciente)
                            }
                          >

                            <i className="bi bi-check-circle-fill"></i>

                            <span>
                              Seleccionar
                            </span>

                          </button>

                        </div>

                      );
                    })}

                </div>

                {/* PAGINACION */}

                <div className="d-flex justify-content-center mt-4">

                  <div className="d-flex flex-wrap gap-2 justify-content-center">

                    <button
                      className="pro-btn-pagination"
                      onClick={() => setCurrentPage(1)}
                    >
                      Inicio
                    </button>

                    <button
                      className="pro-btn-pagination"
                      onClick={() =>
                        setCurrentPage(
                          Math.max(1, currentPage - 10)
                        )
                      }
                    >
                      -10
                    </button>

                    {Array.from(
                      {
                        length: Math.min(
                          Math.ceil(
                            filteredPacientes.length /
                            itemsPerPage
                          ),
                          10
                        ),
                      },
                      (_, index) => (

                        <button
                          key={index}
                          className={`pro-btn-pagination ${
                            currentPage === index + 1
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            setCurrentPage(index + 1)
                          }
                        >
                          {index + 1}
                        </button>

                      )
                    )}

                    <button
                      className="pro-btn-pagination"
                      onClick={() =>
                        setCurrentPage(
                          Math.min(
                            Math.ceil(
                              filteredPacientes.length /
                              itemsPerPage
                            ),
                            currentPage + 10
                          )
                        )
                      }
                    >
                      +10
                    </button>

                    <button
                      className="pro-btn-pagination"
                      onClick={() =>
                        setCurrentPage(
                          Math.ceil(
                            filteredPacientes.length /
                            itemsPerPage
                          )
                        )
                      }
                    >
                      Final
                    </button>

                  </div>

                </div>

              </ModalBody>

              {/* FOOTER */}

              <div className="pro-modal-footer justify-content-end">

                <button
                  className="pro-btn-cancel"
                  onClick={closePacienteModal}
                >

                  <i className="bi bi-x-circle"></i>

                  <span>
                    Cancelar
                  </span>

                </button>

              </div>

            </Modal>

          </div>
          </div>
        </div>
      )}
      {currentForm === "consultaForm" && selected && paciente && formulario && (
        <div className="main-content">
          <ConsultaForm
            onCloseForm={handleCloseForm}
            paciente={paciente}
            formulario={formulario}
            setCurrentForm={setCurrentForm}
          />
        </div>
      )}
    </div>
  );
};

export default MyCalendar;
